import { types } from 'mobx-state-tree'
import { InstitutesLookUpModel } from 'internal'

export default types.model('AdminFilterModel', {
  institutions: types.optional(types.array(InstitutesLookUpModel), []),
  roles: types.optional(types.array(types.string), []),
  userName: types.maybeNull(types.string)
})
